import { useEffect, useState } from "react";
import { saveInLocalStorage } from "../storage/LocalStorage";


export const useOnlineStatus = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOnline = () => {
			saveInLocalStorage("ONLINE", true);
			setIsOnline(true);
		};

		const handleOffline = () => {
			saveInLocalStorage("ONLINE", false);
			setIsOnline(false);
		};

		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);

		saveInLocalStorage("ONLINE", navigator.onLine);
		setIsOnline(navigator.onLine);

		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	return isOnline;
};
